<div class="close-dialog-holder close-dialog-holder--with-title">
  <h2>Personal Details</h2>
  <button
    mat-icon-button
    [mat-dialog-close]="false"
    type="button"
    class="close-dialog-button">
    <mat-icon>clear</mat-icon>
  </button>
</div>

@if (inviteSignupProcessService.identityForm; as form) {
  <form
    (ngSubmit)="submit()"
    [formGroup]="inviteSignupProcessService.identityForm">
    <mat-dialog-content>
      @if (form.controls.firstName) {
        <mat-form-field class="full-width">
          <input
            matInput
            placeholder="{{
              'invite-signup-process-identity.component.first_name_placeholder'
                | localise: 'First Name'
            }}"
            appDisableAutofill
            name="firstName"
            #ctrl="ngControl"
            formControlName="firstName" />
          @if (ctrl.errors?.server; as err) {
            <mat-error>{{ err }}</mat-error>
          }
        </mat-form-field>
      }
      @if (form.controls.lastName) {
        <mat-form-field class="full-width">
          <input
            matInput
            placeholder="{{
              'invite-signup-process-identity.component.last_name_placeholder'
                | localise: 'Last Name'
            }}"
            appDisableAutofill
            name="lastName"
            #ctrl="ngControl"
            formControlName="lastName" />
          @if (ctrl.errors?.server; as err) {
            <mat-error>{{ err }}</mat-error>
          }
        </mat-form-field>
      }
      <div class="question-holder">
        @if (form.controls.line1Address) {
          <mat-form-field class="full-width">
            <input
              matInput
              ngx-google-places-autocomplete
              placeholder="{{
                'invite-signup-process-identity.component.street_address_placeholder'
                  | localise: 'Street Address'
              }}"
              appDisableAutofill
              name="streetAddress"
              formControlName="line1Address"
              #placesRef="ngx-places"
              #ctrl="ngControl"
              (onAddressChange)="handleAddressChange($event)"
              (focus)="setAutoFillOff($event)" />
            @if (ctrl.errors?.server; as err) {
              <mat-error>{{ err }}</mat-error>
            }
          </mat-form-field>
        }
        @if (form.controls.city) {
          <mat-form-field class="full-width">
            <input
              matInput
              placeholder="{{
                'invite-signup-process-identity.component.city_placeholder'
                  | localise: 'City'
              }}"
              name="city"
              appDisableAutofill
              #ctrl="ngControl"
              formControlName="city" />
            @if (ctrl.errors?.server; as err) {
              <mat-error>{{ err }}</mat-error>
            }
          </mat-form-field>
        }
        @if (form.controls.state) {
          <mat-form-field class="full-width">
            <mat-label>{{
              'invite-signup-process-identity.component.state_placeholder'
                | localise: 'State'
            }}</mat-label>
            <mat-select
              [panelClass]="themesService.getDarkThemeClass()"
              formControlName="state"
              #ctrl="ngControl">
              @for (item of statesService.usStatesList; track item) {
                <mat-option [value]="item">
                  {{ item }}
                </mat-option>
              }
            </mat-select>
            @if (ctrl.errors?.server; as err) {
              <mat-error>{{ err }}</mat-error>
            }
          </mat-form-field>
        }
        @if (form.controls.zip) {
          <mat-form-field class="full-width">
            <input
              matInput
              placeholder="{{
                'invite-signup-process-identity.component.zip_placeholder'
                  | localise: 'Zip'
              }}"
              appDisableAutofill
              #ctrl="ngControl"
              formControlName="zip" />
            @if (ctrl.errors?.server; as err) {
              <mat-error>{{ err }}</mat-error>
            }
          </mat-form-field>
        }
      </div>
      @if (form.controls.sendToHomeAddress) {
        <h3>
          {{
            'invite-signup-process-identity.component.where_send_tongo_card'
              | localise: 'Where should we send your Tongo card?'
          }}
        </h3>
        <div class="question-holder">
          <mat-checkbox
            formControlName="sendToHomeAddress"
            (ngModelChange)="onSendToHomeAddressChanged()">
            {{
              'invite-signup-process-identity.component.send_to_home_address'
                | localise: 'Send to my home address'
            }}
          </mat-checkbox>
        </div>
        <div
          class="question-holder"
          [hidden]="form.controls.sendToHomeAddress.value">
          <mat-form-field class="full-width">
            <input
              matInput
              ngx-google-places-autocomplete
              placeholder="{{
                'invite-signup-process-identity.component.street_address_placeholder'
                  | localise: 'Street Address'
              }}"
              appDisableAutofill
              name="shippingStreetAddress"
              formControlName="shippingLine1Address"
              #placesRef="ngx-places"
              #ctrl="ngControl"
              (onAddressChange)="handleShippingAddressChange($event)"
              (focus)="setAutoFillOff($event)" />
            @if (ctrl.errors?.server; as err) {
              <mat-error>{{ err }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="full-width">
            <input
              matInput
              placeholder="{{
                'invite-signup-process-identity.component.city_placeholder'
                  | localise: 'City'
              }}"
              name="shippingCity"
              appDisableAutofill
              #ctrl="ngControl"
              formControlName="shippingCity" />
            @if (ctrl.errors?.server; as err) {
              <mat-error>{{ err }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="full-width">
            <mat-label>{{
              'invite-signup-process-identity.component.state_placeholder'
                | localise: 'State'
            }}</mat-label>
            <mat-select formControlName="shippingState" #ctrl="ngControl">
              @for (item of statesService.usStatesList; track item) {
                <mat-option [value]="item">
                  {{ item }}
                </mat-option>
              }
            </mat-select>
            @if (ctrl.errors?.server; as err) {
              <mat-error>{{ err }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="full-width">
            <input
              matInput
              placeholder="{{
                'invite-signup-process-identity.component.zip_placeholder'
                  | localise: 'Zip'
              }}"
              appDisableAutofill
              #ctrl="ngControl"
              formControlName="shippingZip" />
            @if (ctrl.errors?.server; as err) {
              <mat-error>{{ err }}</mat-error>
            }
          </mat-form-field>
        </div>
      }
      @if (error) {
        <p class="p-error-message p-error-message--margin">
          {{ error }}
        </p>
      }
    </mat-dialog-content>
    <div class="actions" mat-dialog-actions>
      <button
        mat-button
        type="button"
        (click)="inviteSignupProcessService.close.next()">
        {{
          'invite-signup-process-identity.component.close_button'
            | localise: 'Close'
        }}
      </button>
      <button
        type="submit"
        class="p-button p-button--rounded p-button--application-next"
        [disabled]="loading || form.invalid">
        {{
          'invite-signup-process-identity.component.continue_button'
            | localise: 'Continue'
        }}
      </button>
    </div>
  </form>
}
